"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getOverlayBackgroundColor;
function getOverlayBackgroundColor(_ref) {
  var scales = _ref.scales;

  return scales.neutral.N7A;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy90aGVtZS9zcmMvY3JlYXRlLXRoZW1lL2Jhc2Uvb3ZlcmxheUJhY2tncm91bmRDb2xvci5qcyJdLCJuYW1lcyI6WyJnZXRPdmVybGF5QmFja2dyb3VuZENvbG9yIiwic2NhbGVzIiwibmV1dHJhbCIsIk43QSJdLCJtYXBwaW5ncyI6Ijs7Ozs7a0JBQXdCQSx5QjtBQUFULFNBQVNBLHlCQUFULE9BQStDO0FBQUEsTUFBVkMsTUFBVSxRQUFWQSxNQUFVOztBQUM1RCxTQUFPQSxPQUFPQyxPQUFQLENBQWVDLEdBQXRCO0FBQ0QiLCJmaWxlIjoib3ZlcmxheUJhY2tncm91bmRDb2xvci5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIGdldE92ZXJsYXlCYWNrZ3JvdW5kQ29sb3IoeyBzY2FsZXMgfSkge1xuICByZXR1cm4gc2NhbGVzLm5ldXRyYWwuTjdBXG59XG4iXX0=